import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Services() {
  const services = [
    {
      icon: 'ri-shopping-bag-3-line',
      title: '出張買取',
      description: 'ご不要になった家具・家電・骨董品・ブランド品など、専門スタッフがご自宅まで伺い、適正価格で買取いたします。',
      features: [
        '出張費・査定費無料',
        '即日現金買取可能',
        '大型家具・家電も対応',
        '遺品整理にも対応',
      ],
      image: 'https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/492fcf0718d11aa4048f70d7c01460b3.png',
    },
    {
      icon: 'ri-truck-line',
      title: '家財撤去',
      description: '引越し・遺品整理・生前整理に伴う大量の家財も、迅速かつ丁寧に撤去・処分いたします。',
      features: [
        '不用品の分別・搬出',
        '大型家具・家電の解体',
        '一軒まるごと対応可能',
        '適正な廃棄処理',
      ],
      image: 'https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/8872d34182305ec74d63c46368799940.png',
    },
    {
      icon: 'ri-brush-line',
      title: 'ハウスクリーニング',
      description: 'プロの技術と専用機材で、住まいをピカピカに。エアコン・キッチン・浴室など、細部まで徹底清掃します。',
      features: [
        'エアコン分解洗浄',
        'キッチン・レンジフード清掃',
        '浴室・トイレ清掃',
        '空室クリーニング',
      ],
      image: 'https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/87bf4d9d3606093d21a240e35da52a6e.png',
    },
    {
      icon: 'ri-tools-line',
      title: '家電修理',
      description: '冷蔵庫・洗濯機・エアコン・テレビなど、各種家電の故障・不具合を迅速に診断・修理いたします。',
      features: [
        '各メーカー対応可能',
        '出張修理対応',
        '部品交換・メンテナンス',
        '修理後の保証付き',
      ],
      image: 'https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/2ed289ca26aa30701bf2d6d8389d9367.png',
    },
    {
      icon: 'ri-home-smile-line',
      title: 'リフォーム',
      description: 'キッチン・浴室・トイレなどの水回りから、内装・外装まで、住まいの快適性を向上させます。',
      features: [
        '水回りリフォーム',
        '内装・外装工事',
        'バリアフリー改修',
        '無料見積もり・相談',
      ],
      image: 'https://public.readdy.ai/ai/img_res/15aa300674f0d3359a6d742d3a918815.jpg',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '総合サポート',
      description: '暮らしに関するお困りごとは何でもご相談ください。ワンストップで対応いたします。',
      features: [
        '緊急対応可能',
        '複数サービスの組み合わせ',
        'アフターフォロー充実',
      ],
      image: 'https://readdy.ai/api/search-image?query=Friendly%20Japanese%20customer%20service%20representative%20with%20headset%20in%20modern%20office%20with%20natural%20lighting%20clean%20workspace%20and%20professional%20atmosphere%20conveying%20helpfulness%20reliability%20and%20excellent%20support%20with%20warm%20welcoming%20environment&width=800&height=600&seq=service-support-001&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/afd3801847f3ea1b05ae5ddec16ce9af.png)',
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/42 via-black/38 to-black/48"></div>
        
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-4">サービス紹介</h1>
          <p className="text-lg text-white/90">Our Services</p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
              暮らしを支える、<br className="md:hidden" />幅広いサービス
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              飛翠は、お客様の日常生活に関わる様々なサービスを提供しています。<br />
              どんな小さなお困りごとでも、お気軽にご相談ください。
            </p>
          </div>

          <div className="space-y-20">
            {services.map((service, index) => (
              <div
                key={index}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="w-16 h-16 bg-gradient-to-br from-[#A7D676] to-[#76C7E1] rounded-full flex items-center justify-center mb-6">
                    <i className={`${service.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-3xl font-serif text-gray-800 mb-4">{service.title}</h3>
                  <p className="text-base text-gray-600 leading-relaxed mb-6">
                    {service.description}
                  </p>
                  <div className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-3">
                        <i className="ri-check-line text-xl text-[#A7D676]"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="rounded-lg shadow-lg w-full h-[500px] object-cover object-top"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-gradient-to-br from-[#A7D676]/10 to-[#76C7E1]/10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
            サービスに関する<br className="md:hidden" />ご相談はこちら
          </h2>
          <p className="text-base text-gray-600 mb-8 leading-relaxed">
            お見積もりは無料です。お気軽にお問い合わせください。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-[#76C7E1] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#65b6d0] transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-mail-line text-xl mr-2"></i>
              お問い合わせフォーム
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
